import React from 'react';
import styles from '../../../styles/DocumentManagement.module.css';

interface HeaderStatProps {
    overallStats: any;
}

const HeaderStats: React.FC<HeaderStatProps> = ({ overallStats }) => {
    return (
        <div className={styles.statHeroGrid}>
            <div className={`${styles.statHeroCard} ${styles.statHeroCardTotal}`}>
                {/* <span className={styles.statHeroIcon}>📋</span> */}
                <span className={styles.statHeroNumber}>{overallStats?.totalItems ?? 0}</span>
                <span className={styles.statHeroLabel}>Total Items</span>
            </div>
            <div className={`${styles.statHeroCard} ${styles.statHeroCardCompleted}`}>
                {/* <span className={styles.statHeroIcon}>✅</span> */}
                <span className={`${styles.statHeroNumber} ${styles.statHeroNumberCompleted}`}>{overallStats?.completedItems ?? 0}</span>
                <span className={styles.statHeroLabel}>Completed</span>
            </div>
            <div className={`${styles.statHeroCard} ${styles.statHeroCardMissing}`}>
                {/* <span className={styles.statHeroIcon}>📭</span> */}
                <span className={`${styles.statHeroNumber} ${styles.statHeroNumberMissing}`}>{overallStats?.missingItems ?? 0}</span>
                <span className={styles.statHeroLabel}>Missing</span>
            </div>
            <div className={`${styles.statHeroCard} ${styles.statHeroCardExpired}`}>
                {/* <span className={styles.statHeroIcon}>⏰</span> */}
                <span className={`${styles.statHeroNumber} ${styles.statHeroNumberExpired}`}>{overallStats?.expiredItems ?? 0}</span>
                <span className={styles.statHeroLabel}>Expired</span>
            </div>
        </div>
    );
}

export default HeaderStats;